import { render } from "./v-button.vue?vue&type=template&id=9790d21e&scoped=true"
import script from "./v-button.vue?vue&type=script&lang=js"
export * from "./v-button.vue?vue&type=script&lang=js"

import "./v-button.vue?vue&type=style&index=0&id=9790d21e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9790d21e"]])

export default __exports__